<template>
  <div ref="container" class="plv-ia-timer">
    <modal
      ref="modal"
      no-bg
      :style="`z-index: ${zIndex};`"
      :visible="visible || isOngoing"
      :title="t('plvIA.timer.timer')"
      :sub-title="subTitle"
      :sub-title-style="subTitleStyle"
      :draggable="true"
      :close-on-click-modal="false"
      :set-modal-position="setModalPosition"
      :closable="isTeacher"
      @close="handleClose"
    >
      <timer-preparing
        v-if="isTeacher && !isOngoing"
        :enable-time-out="enableTimeOut"
        @change-time-out="changeTimeOut"
        @start="beforeStartTimer"
      />
      <timer-started
        v-else
        :time="remainingTime"
        :is-teacher="isTeacher"
        :is-paused="isPaused"
        :enable-time-out="enableTimeOut"
        @reset="resetTimer"
        @change-status="changePausedStatus"
      />
      <!-- 研讨会选择人群弹窗 -->
      <send-room-modal
        v-if="showSendRoomModal"
        :send-room-title="sendRoomTitle"
        :lang="lang"
        :send-room-list="sendRoomList"
        :confirm-text="sendRoomConfirmText"
        @change-send-room-list="$emit('change-send-room-list', $event)"
        @confirm="handleSendRoomModalConfirm"
        @close="showSendRoomModal = false"
      />
    </modal>
  </div>
</template>

<script>
import Modal from '@/components/modal/Modal';
import TimerPreparing from './TimerPreparing.vue';
import TimerStarted from './TimerStarted.vue';
import SendRoomModal from '../../components/vclass/send-room-modal';
import Locale from '@/mixins/locale';
import sendRoomMixin from '../../mixins/vclass/send-room';
import timerMixin from '../../mixins/timer';
import commonMixin from '../app-mixin';

export default {
  name: 'ILSTimer',

  components: {
    Modal,
    TimerPreparing,
    TimerStarted,
    SendRoomModal
  },

  mixins: [commonMixin, Locale, sendRoomMixin, timerMixin],

  props: {
    /** 是否显示计时器弹窗 */
    visible: {
      type: Boolean,
      default: false,
    },
    /** 当前用户是否为讲师身份 */
    isTeacher: {
      type: Boolean,
      default: false,
    },
    /** 定位上下文元素的唯一 id。计时器弹窗将会相对于该定位上下文进行定位。 */
    mainAreaId: {
      type: String,
      default: '',
    },
    /** 计时器弹窗相对于定位上下文的显示位置。 */
    position: {
      type: String,
      default: 'center',
      validator: (value) => {
        return [
          'center',
          'bottomRight',
          'bottomLeft',
          'topRight',
          'topLeft',
        ].includes(value);
      }
    },
    /** 计时器弹窗样式的 z-index */
    zIndex: {
      type: Number,
      default: 101,
    },
    /** 计时器 SDK 实例 */
    core: {
      type: Object,
      default: null,
    },
  },

  beforeDestroy() {
    this.clearCountDownTimer();
    this.unbindCoreListeners();
  },
};
</script>

<style lang="scss">
@import '../../assets/styles/main.scss';
@font-face {
  font-family: ALIBABAFont;
  src: url('../../assets/styles/fonts/ALIBABAFont.eot');
  src: url('../../assets/styles/fonts/ALIBABAFont.woff') format('woff'),
    url('../../assets/styles/fonts/ALIBABAFont.ttf') format('truetype'),
    url('../../assets/styles/fonts/ALIBABAFont.svg') format('svg');
}
@mixin basicBtn {
  outline: 0;
  border: 0;
  width: 98px;
  height: 36px;
  line-height: 36px;
  border-radius: 20px;
  text-align: center;
  color: #fff;
  background-color: #366BEE;
  cursor: pointer;
  font-size: 14px;

  &:disabled {
    background-color: #BDBDBD;
    cursor: not-allowed;
  }
}
.plv-ia-timer {
  background: #2B2C36;
}

.plv-ia-timer-btn {
  @include basicBtn();
}

.plv-ia-timer-icon-btn {
  @include basicBtn();

  width: 84px;
  height: 28px;
  line-height: 28px;
  border-radius: 14px;
  background-color: #3E3E4F;
  margin: 0 8px;
  padding-left: 36px;
  text-align: left;
  background-repeat: no-repeat;
  background-position: 18px center;
  background-size: 14px;
}

.plv-ia-timer-icon-btn--hignlight, .plv-ia-timer-icon-btn--continue {
  background-color: #366BEE;
}

.plv-ia-timer-icon-btn--continue {
  background-image: url(./images/icon-continue.png);
}

.plv-ia-timer-icon-btn--pause {
  background-image: url(./images/icon-pause.png);
}

.plv-ia-timer-icon-btn--reset {
  background-image: url(./images/icon-reset.png);
}
</style>
